import UICheckbox from 'UIComponents/input/UICheckbox';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { useCallback } from 'react';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputCheckbox = props => {
  const {
    property,
    value,
    disabled,
    onChange,
    readOnly,
    className,
    autoFocus,
    inputRef
  } = props;
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => onChange(SyntheticEvent(checked ? 'true' : 'false')), [onChange]);
  return /*#__PURE__*/_jsx(UICheckbox, Object.assign({}, getTransferrableProps(props), {
    className: className,
    readOnly: readOnly,
    autoFocus: autoFocus,
    disabled: disabled,
    onChange: handleChange,
    checked: value === 'true',
    ref: inputRef,
    children: property && property.description
  }));
};
export default PropertyInputCheckbox;